const FETCH_SPECIAL_OFFERS_REQUEST = 'FETCH_SPECIAL_OFFERS_REQUEST'
const FETCH_SPECIAL_OFFERS_SUCCESS = 'FETCH_SPECIAL_OFFERS_SUCCESS'
const FETCH_SPECIAL_OFFERS_FAILURE = 'FETCH_SPECIAL_OFFERS_FAILURE'

export { FETCH_SPECIAL_OFFERS_REQUEST, FETCH_SPECIAL_OFFERS_SUCCESS, FETCH_SPECIAL_OFFERS_FAILURE }
